// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function noop() {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());


// ----------------
// Helper Functions
// ----------------
(function(w){
	// All helper functions attached to _ad object to avoid polluting the global namespace
	var _ad = w._ad || {};

	// For Each
	_ad.forEach = function(itemInArray, doThis){
		for(var i = 0; i < itemInArray.length; i++)
		{
			doThis(itemInArray[i]);
		}
	};

	// Query String
	_ad.qString = function(url){
		// For current url use: window.location.search
		// Object for holding query variables
		var query = {};

		if (url.indexOf('?') < 0)
			return false;

		// Split the url to get the basic query string
		var queries = url.substr(url.indexOf('?') + 1).split('&');
		_ad.forEach(queries, function(item){
			var key = item.substr(0, item.indexOf('='))
			// var val = item.substr(item.indexOf('=') + 1);
			var val = decodeURIComponent(item.substr(item.indexOf('=') + 1).replace(/\+/g, ' '));
			query[key] = val;
		});

		return query;
	};

	_ad.qStringObj = function(){
		this.query = {};

		this.setup = function(str){
			var query = {};
			if (str.indexOf('?') < 0)
				return false;

			// Split the url to get the basic query string
			var queries = str.substr(str.indexOf('?') + 1).split('&');
			_ad.forEach(queries, function(item){
				var key = item.substr(0, item.indexOf('='))
				// var val = item.substr(item.indexOf('=') + 1);
				var val = decodeURIComponent(item.substr(item.indexOf('=') + 1).replace(/\+/g, ' '));
				query[key] = val;
			});

			return query;
		};

		this.add = function(key, value) {
			if (key === undefined || value === undefined) {
				try {
					console.error('Please enter both a key and a value.');
				}
				catch(err) {
					alert('Please enter both a key and a value.');
				};
				return false;
			}

			this.query[key] = value;
			return value;
		};

		this.remove = function(key) {
			if (key === undefined) {
				try {
					console.error('Please enter a key to remove.')
				}
				catch (err) {
					alert('Please enter a key to remove.')
				};
			}

			if (key in this.query) {
				delete this.query[key];
			} else {
				try {
					console.error('The key "'+key+'" does not exist');
				}
				catch (err) {
					alert('The key "'+key+'" does not exist')
				};
				return false;
			}
			return true;
		};

		this.render = function() {
			var str = '',
				term = '?';


			for (key in this.query) {
				str = str + term + key + '=' +this.query[key];
				term = '&';
			}
			return str;
		};

		if (arguments[0] !== undefined) {
			this.query = this.setup(arguments[0]) || {};
		}
	};

	_ad.formObj = function(elForm){
		if (!elForm) return false;
		this.inputs = {};
		this.elFields = null;

		this.populate = function(){
			var obj = {};
			this.elFields = elForm.querySelectorAll('input, textarea, select');
			for (var i = 0, l = this.elFields.length; i < l; i++) {
				obj[this.elFields[i].name] = this.elFields[i];
			}
			this.inputs = obj;
		};

		this.populate();
	};

	// Transition End
	_ad.bindTransitionEnd = function(toElement, withFunction){
		toElement.addEventListener('transitionend', withFunction, false);
	    toElement.addEventListener('webkitTransitionEnd', withFunction, false);
	    toElement.addEventListener('oTransitionEnd', withFunction, false);
	    toElement.addEventListener('otransitionend', withFunction, false);
	};

	// nthIndexOf
	_ad.nthIndexOf = function(src, target){
		var nth = arguments[2] ? arguments[2] : 1;
		var index = -1;

		for (var i = 0; i < nth; i++)
		{
			index = src.indexOf(target, index + 1);
		}
		return index;
	};

	// Check Height
	_ad.getTallest = function(_el) {
		var height = 0;
		_el.each(function(index, el){
			el.style.height = 'auto';
			var elHeight = parseInt(el.offsetHeight);
			if (elHeight > height) {
				height = elHeight;
			}
		});
		return height;
	}
	_ad.checkHeight = function(_el){
		var height = 0;
		var min = parseInt(_el.css('min-height')) || 0;
		var lineHeight = arguments[1] ? arguments[1] : false // If second parameter is true also set the line-height of the elements //
		height = min;
		_el.css({ height: 'auto' }).each(function(index, element){
			var thisHeight = $(this).outerHeight();
			if (thisHeight > height)
				height = thisHeight;
		}).css({ height: height });

		if (lineHeight)
			_el.css({ lineHeight: height+'px' });

		if (arguments[2] ? arguments[2] : false) { // If third parameter is true then poll for changes //
			setInterval(function(){
				_el.css({ height: _ad.getTallest(_el) });
			}, 500);
		}
		return height;
	};

	// Window Dimensions
	_ad.windowWidth = function() {
		var w = window,
		d = document,
		e = d.documentElement,
		g = d.getElementsByTagName('body')[0],
		x = w.innerWidth || e.clientWidth || g.clientWidth;
		return x;
	}
	_ad.windowHeight = function() {
		var w = window,
		d = document,
		e = d.documentElement,
		g = d.getElementsByTagName('body')[0],
		y = w.innerHeight|| e.clientHeight|| g.clientHeight;
		return y;
	}


	// Cookies
	_ad.createCookie = function (name,value,days) {
		if (days) {
			var date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			var expires = "; expires="+date.toGMTString();
		}
		else expires = "";
		document.cookie = name+"="+value+expires+"; path=/";
	}

	_ad.readCookie = function (name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}

	_ad.scrollTop = function() {
		return (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
	}
	_ad.scrollLeft = function() {
		return (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
	}

	w._ad = _ad;
})(window);


// Transition end event helper
var transEndEventNames = {
		'WebkitTransition': 'webkitTransitionEnd',
		'MozTransition': 'transitionend',
		'OTransition': 'oTransitionEnd',
		'msTransition': 'MSTransitionEnd',
		'transition': 'transitionend'
	},
	transEndEventName = transEndEventNames[Modernizr.prefixed('transition')],
	transEndEventNameConcat = 'webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd';


// Non-jQuery class manipulation //
// Keep this until we totally ditch IE9 //
function addClass(el, className) {
	if (el.classList)
		el.classList.add(className);
	else
		el.className += ' ' + className;
}
function removeClass(el, className) {
	if (el.classList)
		el.classList.remove(className);
	else
		el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}
function toggleClass(el, className) {
	if (el.classList) {
		el.classList.toggle(className);
	} else {
		var classes = el.className.split(' ');
		var existingIndex = -1;
		for (var i = classes.length; i--;) {
			if (classes[i] === className)
				existingIndex = i;
		}

		if (existingIndex >= 0)
			classes.splice(existingIndex, 1);
		else
			classes.push(className);

		el.className = classes.join(' ');
	}
}
function hasClass(el, className) {
	if (el.classList)
		return el.classList.contains(className);
	else
		return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
}


function siblings (el) {
	var siblings;

	if (el.children) {
		siblings = Array.prototype.slice.call(el.parentNode.children);
	} else {
		siblings = Array.prototype.slice.call(children(el.parentNode));
	}

	for (var i = siblings.length; i--;) {
		if (siblings[i] === el) {
			siblings.splice(i, 1);
			break;
		}
	}

	return siblings;
}

// DEPRECATED //
// IE9+ use el.children instead //
function children(el) {
	var children = [];
	for (var i=el.children.length; i--;){
		// Skip comment nodes on IE8
		if (el.children[i].nodeType != 8)
			children.unshift(el.children[i]);
	}
	return children;
}

// DEPRECATED //
// IE9+ just use el.textContent //
function setText(el, text) {
	if (el.textContent !== undefined)
		el.textContent = text;
	else
		el.innerText = text;
}


var attn = {};
// Share Links
attn.shareLinks = function (options) {
    'use strict';
    var self = this;
    self.Opt = new attn.shareLinks.opt(options);
    self.Opt.markup = '';
    self.Opt.ServiceArray = self.Opt.Services.split(',');

    for (var i = 0; i < self.Opt.ServiceArray.length; i++){
        var url = '';
        switch (self.Opt.ServiceArray[i]) {
        case 'twitter':
            url = 'https://twitter.com/intent/tweet?text=' + document.title + '&url=' + window.location;
            break;
        case 'facebook':
            url = 'https://facebook.com/sharer/sharer.php?u=' + window.location;
            break;
        case 'googleplus':
            url = 'https://plus.google.com/share?url=' + window.location;
            break;
        case 'linkedin':
            url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + window.location + '&title=' + document.title;
            break;
        case 'pinterest':
            url = 'https://pinterest.com/pin/create/button/?url=' + window.location + '&media=' + window.location + '&description=' + document.title;
            break;
        }
        self.Opt.markup += '<a href="' + encodeURI(url) + '" class="' + self.Opt.LinkClassPrefix + self.Opt.ServiceArray[i] + '" target="_blank"><span class="' + self.Opt.TextClass + '">Share on ' + self.Opt.ServiceArray[i] + '</span></a> ';
    }

    var elWrappers = document.querySelectorAll(self.Opt.Wrapper);

    for (var i = 0, l = elWrappers.length; i < l; i++) {
    	elWrappers[i].innerHTML += self.Opt.markup;
    }
};
attn.shareLinks.opt = function (options) {
    'use strict';
    options && options.wrapper ? this.Wrapper = options.wrapper : this.Wrapper = '.shareLinks'; // selector of the wrapping element
    options && options.services ? this.Services = options.services : this.Services = 'twitter,facebook,googleplus,linkedin'; // comma delimited list of services to show
    options && options.linkClassPrefix ? this.LinkClassPrefix = options.linkClassPrefix : this.LinkClassPrefix = ''; // prefix for the class of each link (the service name is the suffix)
    options && options.textClass ? this.TextClass = options.textClass : this.TextClass = ''; // class for the span element within the link
};

export { addClass, removeClass, toggleClass, hasClass, siblings, children, setText, transEndEventNameConcat, attn };